module.exports = __webpack_public_path__ + "static/media/mobile-android-alt.bdcc74c4.svg";